import ApiService from './ApiService';

export default class SystemSettingApi extends ApiService {
    constructor() {
        super('system');
    }

    getSystemSetting(payload) {
        return this.get('general-settings', payload);
    }

    updateSystemSetting(payload) {
        return this.put('general-settings', payload);
    }

    getMileageLimitAndDropOffSetting(payload) {
        return this.get('settings/mileage-limit', payload);
    }

    updateMileageLimitAndDropOffSetting(payload) {
        return this.put('settings/mileage-limit', payload);
    }
}
